import { type LoginPageOptions, type LoginTask } from './types';

export const loginTasksFram: LoginTask[] = [
  { title: 'loginPage.tasks.products.fokus' },
  {
    title: 'loginPage.tasks.products.fokus.confirmation',
  },
  {
    title: 'loginPage.tasks.products.fokus.overview',
  },
];

export const loginSmartPension: LoginPageOptions = {
  tasks: [
    { title: 'productPageSmartKonto.tasks.rente' },
    { title: 'productPageSmartKonto.tasks.uttak' },
    { title: 'productPageSmartKonto.tasks.pensjon' },
  ],
  header: 'productPageSmartKonto.header',
  showPrices: true,
};

export const loginTasksDefault: LoginTask[] = [
  { title: 'loginPage.tasks.products' },
  { title: 'loginPage.tasks.about' },
  { title: 'loginPage.tasks.sign' },
];

export const loginConsumerLoan: LoginPageOptions = { tasks: loginTasksDefault, header: 'loginPage.header' };

export const loginTasksStandardBank: LoginTask[] = [
  {
    title: 'productStandardBank.1.title',
    subTitle: 'productStandardBank.1.subTitle',
  },
  { title: 'productStandardBank.2.title', subTitle: 'productStandardBank.2.subTitle' },
  { title: 'productStandardBank.3.title', subTitle: 'productStandardBank.3.subTitle' },
];

export const loginDepositAccount: LoginPageOptions = {
  tasks: [
    { title: 'loginPage.depositAccount.tasks.about' },
    { title: 'loginPage.depositAccount.tasks.sign' },
    { title: 'loginPage.depositAccount.tasks.tenant' },
  ],
  header: 'loginPage.depositAccount.header',
};

export const loginFixedDeposit3Months: LoginPageOptions = {
  header: 'productPageFixedDepositAccount3Months.header',
  ingress: 'productPageFixedDepositAccount3Months.ingress',
  tasks: [
    { title: 'productPageFixedDepositAccount3Months.tasks.1' },
    { title: 'productPageFixedDepositAccount3Months.tasks.2' },
    { title: 'productPageFixedDepositAccount3Months.tasks.3' },
  ],
  showPrices: true,
};

export const loginFixedDeposit6Months: LoginPageOptions = {
  header: 'productPageFixedDepositAccount6Months.header',
  tasks: [
    { title: 'productPageFixedDepositAccount6Months.tasks.1' },
    { title: 'productPageFixedDepositAccount6Months.tasks.2' },
    { title: 'productPageFixedDepositAccount6Months.tasks.3' },
  ],
  ingress: 'productPageFixedDepositAccount6Months.ingress',
  showPrices: true,
};

export const loginHighInterestAccount: LoginPageOptions = {
  header: 'productHighInterestAccount.header',
  tasks: [
    { title: 'productHighInterestAccount.tasks.1' },
    { title: 'productHighInterestAccount.tasks.2' },
    { title: 'productHighInterestAccount.tasks.3' },
    { title: 'productHighInterestAccount.tasks.4' },
  ],

  ingress: 'productHighInterestAccount.ingress',
  showPrices: true,
};

export const loginPlacementAccountOrdinary: LoginPageOptions = {
  header: 'productPagePlacementAccountOrdinary.header',
  tasks: [
    { title: 'productPage.placementAccountOrdinary.tasks.1' },
    { title: 'productPage.placementAccountOrdinary.tasks.2' },
    { title: 'productPage.placementAccountOrdinary.tasks.3' },
  ],

  ingress: 'productPagePlacementAccountOrdinary.ingress',
  showPrices: true,
};

export const loginEmergencyFoundsOrinary: LoginPageOptions = {
  header: 'productEmergencyFundsOrdinary.header',
  tasks: [
    { title: 'productEmergencyFundsOrdinary.tasks.1' },
    { title: 'productEmergencyFundsOrdinary.tasks.2' },
    { title: 'productEmergencyFundsOrdinary.tasks.3' },
  ],
  showPrices: true,
};

export const loginHighInterestAccountWealth: LoginPageOptions = {
  header: 'productHighInterestAccountWealth.header',
  tasks: [
    { title: 'productHighInterestAccountWealth.tasks.1' },
    { title: 'productHighInterestAccountWealth.tasks.2' },
    { title: 'productHighInterestAccountWealth.tasks.3' },
  ],
  ingress: 'productHighInterestAccountWealth.ingress',
  showPrices: true,
};

export const loginSavingsAccount: LoginPageOptions = {
  header: 'productSavingsAccount.header',
  tasks: [
    { title: 'productSavingsAccount.tasks.1' },
    { title: 'productSavingsAccount.tasks.2' },
    { title: 'productSavingsAccount.tasks.3' },
  ],
  ingress: 'productSavingsAccount.ingress',
  showPrices: true,
};
